module.exports = __webpack_public_path__ + "static/img/newlogin_bg.96978c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/newlogin_bg.png
// module id = GiyJ
// module chunks = 1